export default "__VITE_ASSET__B9du9Oj3__"